import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ActivityIndicator from '../ActivityIndicator/ActivityIndicator.js'
import './DetailsTable.css'
import StandardPerformanceTable from 'wt-react/dist/components/StandardPerformance/StandardPerformanceTable.js'
import DetailsTable from 'wt-react/dist/components/StandardPerformance/DetailsTable.js'

const FundDetailsTable = ({ fund, bmk }) => {
  const [fundId, setFundId] = useState(null);
  const [bmkId, setBmkId] = useState(null);
  const [showTab, setShowTab] = useState('performance')
  const [performanceData, setPerformanceData] = useState(null);

  const renderFundDetails = async () => {
    console.log(fund);
    console.log(bmk);

    if (fund !== undefined && bmk !== undefined) {
      const url1 = `${process.env.REACT_APP_API_URL}/fundchar/typeahead/?q=${fund}&wtRegion=US`;
      const url2 = `${process.env.REACT_APP_API_URL}/fundchar/typeahead/?q=${bmk}&wtRegion=US`;

      try {
        const fundResponse = await axios.get(url1);
        console.log(fundResponse.data[0].externalID);
        setFundId(fundResponse.data[0].externalID);

        const bmkResponse = await axios.get(url2);
        console.log(bmkResponse.data[0].externalID);
        setBmkId(bmkResponse.data[0].externalID);
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    renderFundDetails();
  }, [fund, bmk]);

  useEffect(() => {
    if (fundId !== null && bmkId !== null) {
      const url = `${process.env.REACT_APP_API_URL}/fundchar/performance/?&q=${fundId}&q=${bmkId}`;
  
      const fetchData = async () => {
        try {
          const response = await axios.get(url);
          console.log(response.data);
          setPerformanceData(response.data);
        } catch (error) {
          console.error(error);
        }
      };
      fetchData();
    }
  }, [fundId, bmkId]);
  

  if (performanceData === null || performanceData === undefined || !performanceData){
    return <ActivityIndicator/>
  }

  return (
    <div className='fund-attr-details'>
      <div className='selection-buttons'>
        <div className='performance-button'>
          <button
            className={showTab === 'performance' ? 'active' : 'not-active'}
            onClick={() => setShowTab('performance')}
          >
            PERFORMANCE
          </button>
        </div>
        <div className='details-button'>
          <button
            className={showTab === 'details' ? 'active' : 'not-active'}
            onClick={() => setShowTab('details')}
          >
            FUND DETAILS
          </button>
        </div>
      </div>
      
      {showTab === 'performance' ? (
        <StandardPerformanceTable
          data={[performanceData[0], performanceData[1]]}
          showTitle={false}
          showCommonPeriod={false}
          commonPeriodStart={performanceData[0] ? performanceData[0].stdPerformance[0].commonPeriodNAVStart : null}
          commonPeriodEnd={performanceData[0] ? performanceData[0].stdPerformance[0].commonPeriodNAVEnd : null} 
          isPortfolio={false}
          showSinceInception={false}
          showPerfFootnote={true}
          hideCumulativeReturns={true}
          wtFundsOnly={true}
          sidePadding={100}
        />
      ) : (
        <DetailsTable
          data={[performanceData[0], performanceData[1]]}
          showTitle={false}
          showCommonPeriod={false}
          isPortfolio={false}
          showPerfFootnote={true}
          sidePadding={100}
        />
      )}
    </div>
  );
  
};

export default FundDetailsTable;













// WEBPACK FOOTER //
// ./src/components/App/DetailsTable/FundDetailsTable.js